module.exports = __webpack_public_path__ + "static/media/chicken.09c8c2f8.svg";